import { createSlice } from '@reduxjs/toolkit'

import type { PayloadAction } from '@reduxjs/toolkit'

const initialState = {
  oneTimeEmailOtpVerified: false
}

export const oneTimeEmailOtpSlice = createSlice({
  name: 'oneTimeEmailOtp',
  initialState,
  reducers: {
    setOneTimeEmailOtpVerified(state, action: PayloadAction<boolean>) {
      state.oneTimeEmailOtpVerified = action.payload
    }
  }
})
export const { setOneTimeEmailOtpVerified } = oneTimeEmailOtpSlice.actions
export default oneTimeEmailOtpSlice
